import { render } from "./MousePointerComp.vue?vue&type=template&id=e588c1a2&scoped=true"
import script from "./MousePointerComp.vue?vue&type=script&lang=js"
export * from "./MousePointerComp.vue?vue&type=script&lang=js"

import "./MousePointerComp.vue?vue&type=style&index=0&id=e588c1a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e588c1a2"]])

export default __exports__